
const THEME_CLASS_PREFIX = 'theme--';
const SITE_THEMES = ['swegon-green', 'swegon-blue', 'air-academy-dusk', 'turquoise', 'consumer', 'action-air'];

function getSectionThemeClasses() {
    let section = document.querySelector('[data-theme-scope]') || document.querySelector('main') || document.body;
    while (section) {
        const explicitTheme = section.getAttribute('data-site-theme');
        if (SITE_THEMES.includes(explicitTheme)) return [THEME_CLASS_PREFIX + explicitTheme];

        // A block's Pale/Dark/Consumer scheme must not become the header identity.
        if (!section.classList.contains('panel')) {
            const theme = SITE_THEMES.find(name => section.classList.contains(THEME_CLASS_PREFIX + name));
            if (theme) return [THEME_CLASS_PREFIX + theme];
        }
        section = section.parentElement;
    }
    return [];
}

function applyThemeClassesToHeader(themeClasses) {
    const header = document.querySelector('.header');
    if (!header) return;

    // Remove any existing theme classes from the header
    const existing = [...header.classList].filter((cls) => cls.startsWith(THEME_CLASS_PREFIX));
    if (existing.length) {
        header.classList.remove(...existing);
    }

    if (themeClasses.length) {
        header.classList.add(...themeClasses);
    }
}

export default function initSectionTheme() {
    const themeClasses = getSectionThemeClasses();
    if (themeClasses.length) {
        applyThemeClassesToHeader(themeClasses);
    }
}
